// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 3.94055L12 0.440552L2 3.94055V12C2 16.1271 4.53351 19.0117 6.89576 20.8031C8.08675 21.7063 9.27184 22.3623 10.1566 22.7924C10.6002 23.008 10.9717 23.1685 11.2352 23.2761C11.3671 23.33 11.4722 23.3707 11.546 23.3985C11.6592 23.4412 11.7735 23.4808 11.8878 23.5205C11.9252 23.5335 11.9626 23.5464 12 23.5595C12.0379 23.5463 12.0757 23.5331 12.1136 23.52C12.2275 23.4805 12.3413 23.441 12.454 23.3985C12.5278 23.3707 12.6329 23.33 12.7648 23.2761C13.0283 23.1685 13.3998 23.008 13.8434 22.7924C14.7282 22.3623 15.9133 21.7063 17.1042 20.8031C19.4665 19.0117 22 16.1271 22 12V3.94055ZM11.0014 15.4142L6.75879 11.1716L8.173 9.75738L11.0014 12.5858L16.6583 6.92896L18.0725 8.34317L11.0014 15.4142Z"}}]};

const SecuredFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'secured-filled',
    ref,
    icon: element,
  },
));

SecuredFilledIcon.displayName = 'SecuredFilledIcon';

export default SecuredFilledIcon;
